import { LoyaltyLotKind, LoyaltyTransactionType } from '@repo/api/web/models'
import { injectable } from 'inversify'

const LOT_KIND_LABELS: Record<LoyaltyLotKind, string> = {
  [LoyaltyLotKind.CASHBACK]: 'Кэшбэк',
  [LoyaltyLotKind.PROMO]: 'Промо',
}

const TRANSACTION_TYPE_LABELS: Record<LoyaltyTransactionType, string> = {
  [LoyaltyTransactionType.CASHBACKACCRUAL]: 'Начисление кэшбэка',
  [LoyaltyTransactionType.PROMOACCRUAL]: 'Начисление по акции',
  [LoyaltyTransactionType.REDEMPTION]: 'Списание',
  [LoyaltyTransactionType.REDEMPTIONHOLD]: 'Холд списания',
  [LoyaltyTransactionType.REDEMPTIONRELEASE]: 'Снятие холда',
  [LoyaltyTransactionType.EXPIRATION]: 'Сгорание',
  [LoyaltyTransactionType.STORNOACCRUAL]: 'Сторно начисления',
  [LoyaltyTransactionType.STORNOPROMOACCRUAL]: 'Сторно promo-начисления',
  [LoyaltyTransactionType.MANUALADJUSTMENT]: 'Корректировка',
}

@injectable()
export class LoyaltySupport {
  lotKindLabel(kind: LoyaltyLotKind): string {
    return LOT_KIND_LABELS[kind] ?? kind
  }

  transactionTypeLabel(type: LoyaltyTransactionType): string {
    return TRANSACTION_TYPE_LABELS[type] ?? type
  }

  isCredit(type: LoyaltyTransactionType): boolean {
    return type === LoyaltyTransactionType.CASHBACKACCRUAL
      || type === LoyaltyTransactionType.PROMOACCRUAL
      || type === LoyaltyTransactionType.REDEMPTIONRELEASE
      || type === LoyaltyTransactionType.MANUALADJUSTMENT
  }
}
